import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import * as kestrelEmbedCode from "shared/kestrel-embed-code";
import * as yup from "yup";
import { validate } from "shared/yup";
import { getOffices } from "redux/selector";
import { WidgetConfigLayout } from "../widget-config-layout";
import { WidgetFieldGrid, WidgetFieldCell, WidgetSelect } from "../widget-fields";
import { getUser } from "redux/selector";

const mapStateToProps = (state: RootState) => {
	return {
		user: getUser(state),
		offices: getOffices(state),
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends 
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps> {
}

interface State {
	officeId: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props) 
		this.state = {
			officeId: "",
		}
	}

	private validationSchema = {
		officeId: yup
			.string()
			.required("Office is required.")
	};

	public render() {
		const { user, offices } = this.props;
		const { officeId } = this.state;
		const errors = validate(this.validationSchema, this.state);
		const embedCode = kestrelEmbedCode.officeListingsWidget(
			user.websitePlatform,
			parseInt(officeId),
		);
		return (
			<WidgetConfigLayout user={user} embedCode={!errors ? embedCode : undefined}>
				<WidgetFieldGrid>
					<WidgetFieldCell full>
						<WidgetSelect
							label="Office"
							required
							value={officeId}
							options={offices.map((office) => ({value: office.id, label: office.name}))}
							onChange={(value) => this.setState({officeId: value})}
						/>
					</WidgetFieldCell>
				</WidgetFieldGrid>
			</WidgetConfigLayout>
		);
	}
}

export const OfficeListingsConfig = (
	connect(mapStateToProps, mapDispatchToProps)(Component)
);